export const TIME_OFF_REQUESTS_EXPORT_XLSX_TIMEOUT = 60 * 1000 * 3; //3 mins
